// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/mediasidebar/directives/ContactDirective.scss
// module id = 1268
// module chunks = 0